import { v4 as uuidv4 } from 'uuid';

export function DrawerCloseButton(props) {
	return {
		componentName: 'DrawerCloseButton',
		componentId: uuidv4(),
		props,
		childrenComponents: [],
	};
}
